import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { register } from "../../actions/userActions";
import Loader from "../main/Loader";
import Message from "../main/Message";
import { loadRecaptcha, getRecaptchaToken } from "../../utils/recaptcha";

function Register() {
  // Selectors
  const userRegister = useSelector((state) => state.userRegister);
  const { error, loading, success } = userRegister;

  // Dispatch and Navigate
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // State Etc
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [website, setWebsite] = useState(""); // honeypot, hidden from real users
  const loadedAt = useRef(Date.now());
  const location = useLocation();
  const redirect = location.search
    ? location.search.split("=")[1]
    : "/activate-sent";

  // useEffects
  useEffect(() => {
    if (success) {
      navigate(redirect, { replace: true });
    }
  }, [navigate, success, redirect]);

  // Load reCAPTCHA v3 once
  useEffect(() => {
    loadRecaptcha();
  }, []);

  // Submit
  const submitHandler = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setMessage("Passwords do not match");
    } else {
      // Token is fetched at submit since tokens expire after 2 minutes
      const recaptchaToken = await getRecaptchaToken("register");
      dispatch(
        register(name, email, password, {
          website,
          elapsedMs: Date.now() - loadedAt.current,
          recaptchaToken,
        })
      );
    }
  };

  // Navs and Footer
  useEffect(() => {
    const nav = document.querySelector(".navigation-large");
    nav.className =
      "navigation-large d-none d-md-flex justify-content-between fixed-top section-bg";
  }, []);

  useEffect(() => {
    const nav = document.querySelector(".navigation-small");
    nav.className =
      "navigation-small d-flex justify-content-between d-md-none fixed-top section-bg";
  }, []);

  useEffect(() => {
    const footer = document.querySelector(".footer-contain");
    footer.className = "footer-contain section-bg";
  }, []);

  return (
    <Container className="section-contain">
      {loading ? (
        <Loader />
      ) : (
        <>
          {message && (
            <Row className="message-contain">
              <Col md={12}>
                <Message variant="danger">{message}</Message>
              </Col>
            </Row>
          )}
          {error && (
            <Row className="message-contain">
              <Col md={12}>
                <Message variant="danger">{error}</Message>
              </Col>
            </Row>
          )}
          <Form onSubmit={submitHandler}>
            <Row>
              <Col md={12}>
                <h1 className="header">Register</h1>
              </Col>
              <Col lg={6}>
                <Form.Group className="mb-3" controlId="name">
                  <Form.Label>Full Name</Form.Label>
                  <Form.Control
                    required
                    type="name"
                    placeholder=""
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </Form.Group>
                <Form.Group className="mb-3" controlId="email">
                  <Form.Label>Email address</Form.Label>
                  <Form.Control
                    required
                    type="email"
                    placeholder=""
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </Form.Group>
                <Form.Group className="mb-3" controlId="password">
                  <Form.Label>Password</Form.Label>
                  <Form.Control
                    required
                    type="password"
                    placeholder=""
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </Form.Group>
                <Form.Group className="mb-3" controlId="passwordConfirm">
                  <Form.Label>Confirm Password</Form.Label>
                  <Form.Control
                    required
                    type="password"
                    placeholder=""
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />
                </Form.Group>
                <div
                  aria-hidden="true"
                  style={{ position: "absolute", left: "-10000px" }}
                >
                  <label htmlFor="website">Website</label>
                  <input
                    type="text"
                    id="website"
                    name="website"
                    tabIndex="-1"
                    autoComplete="off"
                    value={website}
                    onChange={(e) => setWebsite(e.target.value)}
                  />
                </div>
              </Col>
              <Col md={12} className="form-link">
                <Button type="submit" variant="primary">
                  Register
                </Button>
              </Col>
              <Col md={12} className="form-link">
                Do you already have an account? <Link to="/login">Log in</Link>
              </Col>
            </Row>
          </Form>
        </>
      )}
    </Container>
  );
}

export default Register;
